<script setup>
import { defineEmits } from 'vue'

const emit = defineEmits(['close'])

const close = () => {
    emit('close')
}

</script>
<template>
    <Teleport to="body">
        <div
            class="w-screen h-screen fixed top-0 left-0 bg-gray-300/50 dark:bg-neutral-800/50 flex"
            @click="close()"
        >
            <div
                class="m-auto w-[640px] max-w-full rounded-xl shadow-xl bg-white dark:bg-neutral-800 p-8 flex flex-col gap-4"
                @click.stop="()=>{}"
            >
                <slot/>
            </div>
        </div>
    </Teleport>
</template>
